<template>
  <p class="control lxm-login-input"
     :class="controlClass"
     @click="clicked">
    <input class="input"
           :class="inputClass"
           :type="type"
           :placeholder="placeholderGetter"
           :value="valueGetter"
           ref="input"
           @input="inputted"
           @change="changed"
           @blur="blurred"
           @focus="focused">
    <label v-if="label" class="label">{{ label }}</label>
    <span ref="error" v-show="hasError" class="lxm-login-input__error">
      <img src="../../images/login/error.png" />
      {{ errorGetter }}
    </span>
    <span v-if="help" class="help">{{ help }}</span>
  </p>
</template>

<style lang="stylus" scoped>
  @import '../../styles/index.styl'
  input-font-size = siz(12)
  error-border = 1px solid color-error
  transition-time = 0.5s
  .control
    &.lxm-login-input
      .input
        box-shadow: none
        border: 0
        height: login-control-height
        font-size: siz(14)
        color: login-input-text
        border-radius: login-radius
        padding-left: siz(17)
        // transition: border transition-time
      .help
        font-size: siz(12)
        margin-top: spacing-small
      .input.is-error
        border: error-border
      .lxm-login-input__error
        position: absolute
        right: siz(10)
        top: siz(11)
        color: color-error
        font-size: size
        img
          width: siz(17)
          height: siz(17)
          vertical-align: text-bottom
      // 设计是 brand-primary ，产品认为应该区分 placeholder 和用户输入
      ::placeholder
        color: grey
      ::-webkit-input-placeholder
        color: grey
      :-moz-placeholder
        color: grey
      ::-moz-placeholder
        color: grey
      :-ms-input-placeholder
        color: grey
      &.lxm-login-input--transparent
        .input
          background-color: #F5F6F8
          color: login-input-text
        .input.is-error
          border: error-border
        ::placeholder
          color: grey
        ::-webkit-input-placeholder
          color: grey
        :-moz-placeholder
          color: grey
        ::-moz-placeholder
          color: grey
        :-ms-input-placeholder
          color: grey
    &.lxm-login-input--has-label
      & > .label
        position: absolute
        top: siz(12.5)
        z-index: 4
        left: siz(15)
        color: grey
        font-weight: normal
        font-size: input-font-size
        line-height: 1
      .input
        padding-left: siz(104)
    &.lxm-login-input--has-text-centered
      .input
        text-align: center
</style>

<script>
  /* global $: false */
  export default {
    props: {
      transparent: Boolean,
      error: String,
      help: String,
      center: Boolean,
      label: String,
      placeholder: String,
      value: String,
      type: String
    },
    data () {
      return {
        oldError: '',
        animating: false
      }
    },
    computed: {
      controlClass () {
        return {
          'lxm-login-input--has-label': this.label,
          'lxm-login-input--has-text-centered': this.center,
          'lxm-login-input--transparent': this.label || this.center || this.transparent
        }
      },
      inputClass () {
        return {
          'is-error': this.error
        }
      },
      hasError () {
        if (this.error) {
          return true
        } else {
          return this.animating
        }
      },
      errorGetter () {
        return this.error || this.oldError
      },
      valueGetter () {
        return this.hasError ? '' : this.value
        // return this.value
      },
      placeholderGetter () {
        return this.hasError ? '' : this.placeholder
      }
    },
    methods: {
      inputted (e) {
        this.$emit('input', e)
      },
      changed (e) {
        this.$emit('change', e)
      },
      blurred (e) {
        this.$emit('blur', e)
      },
      focused (e) {
        this.$emit('focus', e)
      },
      clicked (e) {
        this.$refs.input.focus()
        this.$emit('click', e)
      },
      focus () {
        this.$refs.input.focus()
      }
    },
    watch: {
      error (newError) {
        this.animating = true
        const $error = $(this.$refs.error)
        const duration = 1
        if (newError) {
          $error.css('opacity', 0)
          $error.animate({ opacity: 1 }, duration, 'swing', () => {
            this.oldError = newError
            this.animating = false
          })
        } else {
          $error.css('opacity', 1)
          $error.animate({ opacity: 0 }, duration, 'swing', () => {
            this.oldError = newError
            this.animating = false
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// InputBase.vue?50de81aa